import { useEffect } from 'react';
import Typography from '@components/common/typography';
import Button from '@components/common/button';
import styles from './styles.module.scss';
import { motion } from 'framer-motion';
import { pageAnimation } from '@const/animation';
import useSignupContext from '@hooks/context/useSignupContext';
import launchIllustration from '@svg/illustrations/auth/launch.svg';

const LaunchSoonLayout = () => {
    const { handleChangeIllustration } = useSignupContext();

    useEffect(() => {
        handleChangeIllustration(launchIllustration);
    }, []);

    return (
        <motion.div {...pageAnimation} className={styles.wrapper}>
            <Typography className={styles.title} variant="h3">
                Launching soon
            </Typography>
            <Typography className={styles.description} variant="body2">
                Join the waitlist to be among the first to access the app
            </Typography>
            <Button
                onClick={() => window.open('https://xeppt.com/#footer_hero_form', '_blank')}
                variant="primary"
                rightIcon="arrow_right">
                Join the waitlist
            </Button>
        </motion.div>
    );
};
export default LaunchSoonLayout;
